import { render, staticRenderFns } from "./PicturePool.vue?vue&type=template&id=1c67b81e&scoped=true"
import script from "./PicturePool.vue?vue&type=script&lang=js"
export * from "./PicturePool.vue?vue&type=script&lang=js"
import style0 from "./PicturePool.vue?vue&type=style&index=0&id=1c67b81e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c67b81e",
  null
  
)

export default component.exports